<script>
    export let name, search;
</script>

<h4>{name} :</h4>
<a href="https://www.google.com/search?q={encodeURI(search)}" target="_blank" rel="noopener noreferrer">
    {search}
</a>

<style>
a {
	font-size: 18px;
	color: #45aaf2;
	text-decoration: none;
	margin-top: 500px;
}
a:hover {
	text-decoration: underline;
}

a:visited {
	color: #2d98da;
}
</style>